import { createAction } from '@reduxjs/toolkit'
import { createPromiseAction } from 'redux-saga-promise-actions'
import * as types from './types'

export const getChats = createAction(types.GET_CHATS)

// utilizar o redux-thunk para enviar a info que esta em um slice (reducer) diferente do atual
export const getChatsThunk = dataFromComponent => (dispatch, getState) => {
  const state = getState()
  const currentRoomType = state.room_menu.current_room_type
  const archivedSection = dataFromComponent?.archivedRooms
  const archivedRoomType = state.room_menu.archived_section.room_type
  const finalPayload = {
    ...dataFromComponent,
    room_type: archivedSection ? archivedRoomType : currentRoomType
  }
  dispatch(getChats(finalPayload))
}

export const clearPrivateRooms = createAction(types.CLEAR_PRIVATE_ROOMS)
export const getPrivateRoomsSuccessful = createAction(
  types.GET_PRIVATE_ROOMS_SUCCESSFUL
)
export const setPrivateRoomsOrder = createAction(types.SET_PRIVATE_ROOMS_ORDER)
export const setGroupRoomsOrder = createAction(types.SET_GROUP_ROOMS_ORDER)
export const setMediationRoomsOrder = createAction(
  types.SET_MEDIATION_ROOMS_ORDER
)

export const clearGroupRooms = createAction(types.CLEAR_GROUP_ROOMS)
export const getGroupRoomsSuccessful = createAction(
  types.GET_GROUP_ROOMS_SUCCESSFUL
)

export const clearArchivedRooms = createAction(types.CLEAR_ARCHIVED_ROOMS)
export const getArchivedRoomsSuccessful = createAction(
  types.GET_ARCHIVED_ROOMS_SUCCESSFUL
)

export const clearMediationRooms = createAction(types.CLEAR_MEDIATION_ROOMS)
export const getMediationRoomsSuccessful = createAction(
  types.GET_MEDIATION_ROOMS_SUCCESSFUL
)

export const getChatsSuccessful = createAction(types.GET_CHATS_SUCCESSFUL)
export const getChatsFailure = createAction(types.GET_CHATS_FAILURE)

export const createChatRSPA = createPromiseAction(types.CREATE_CHAT_RSPA)()
export const createChatSuccessful = createAction(types.CREATE_CHAT_SUCCESSFUL)
export const createChatFailure = createAction(types.CREATE_CHAT_FAILURE)

export const getChatById = createAction(types.GET_CHAT_BY_ID)
export const getChatByIdSuccessful = createAction(
  types.GET_CHAT_BY_ID_SUCCESSFUL
)
export const getChatByIdFailure = createAction(types.GET_CHAT_BY_ID_FAILURE)

export const deleteChat = createAction(types.DELETE_CHAT)
export const deleteChatSuccessful = createAction(types.DELETE_CHAT_SUCCESSFUL)
export const deleteChatFailure = createAction(types.DELETE_CHAT_FAILURE)

export const createMessageRSPA = createPromiseAction(
  types.CREATE_MESSAGE_RSPA
)()
export const getMessagesRSPA = createPromiseAction(types.GET_MESSAGES_RSPA)()
export const getInterventionMessagesRSPA = createPromiseAction(
  types.GET_INTERVENTION_MESSAGE_RSPA
)()
export const getMessagesWithoutRoomRSPA = createPromiseAction(
  types.GET_MESSAGES_WITHOUT_ROOM_RSPA
)()
export const getRoomsRSPA = createPromiseAction(types.GET_ROOMS_RSPA)()
export const getRoomsByIdRSPA = createPromiseAction(types.GET_ROOM_BY_ID_RSPA)()

export const editMessageRSPA = createPromiseAction(types.EDIT_MESSAGE_RSPA)()
export const deleteMessageRSPA = createPromiseAction(
  types.DELETE_MESSAGE_RSPA
)()
export const exportMessagesRSPA = createPromiseAction(
  types.EXPORT_MESSAGES_RSPA
)()

export const editRoomRSPA = createPromiseAction(types.EDIT_ROOM_RSPA)()
export const updateGroupRoomReducer = createAction(
  types.UPDATE_GROUP_ROOM_REDUCER
)
export const filterArchived = createAction(types.FILTER_ARCHIVED)
